import { removeItem } from "@/utils/va-order-test/testAndPanelSelection/index.js";
import { getEditOrderItemsForDisplay, handleEditOrderItemSelection, getEditOrderItemSampleTypes } from "./helpers/orderDraft.js";
import { handleException } from "@/utils/va-order-test/testAndPanelSelection/handleException.js";
import _ from "lodash";

const orderDraft = {
  namespaced: true,
  state: {
    orderDraft: {},
    currentDraftId: "",
    draftList: [],
    loadDraft: {
      customPanel: false,
      orderTestPanel: false,
    },
    editOrderItemList: []
  },
  mutations: {
    SET_ORDER_DRAFT(state, orderDraft) {
      state.orderDraft = orderDraft;
    },
    SET_CURRENT_DRAFT_ID(state, id) {
      state.currentDraftId = id;
    },
    SET_DRAFT_LIST(state, draftList) {
      state.draftList = []
      if (draftList && draftList.length > 0) {
        draftList.forEach((row) => {
          let tmp = {};
          tmp.draftId = row.orderDraftId;
          let localDate = new Date(row.modifiedTime).toLocaleString("en-US", {
            localeMatcher: "best fit",
            hour12: false,
            year: "numeric",
            day: "2-digit",
            month: "2-digit",
            hour:"2-digit",
            minute: "2-digit",
            second: "2-digit",
          }).replaceAll("/", "-").replace(",", "");          
          tmp.modifiedTime = localDate;
          tmp.draftName = row.draftName;
          tmp.dob = row.dob
            ? row.dob.slice(5, 7) +
              "/" +
              row.dob.slice(8, 10) +
              "/" +
              row.dob.slice(0, 4)
            : "";
          tmp.gender = row.gender;
          tmp.name = row.patientName;
          tmp.isClinic = row.isClinic;
          state.draftList.push(tmp);
        });
      }
    },
    REMOVE_DRAFT(state, draftID) {
      let index = 0;
      state.draftList.forEach((row, i) => {
        if (row.draftId === draftID) {
          index = i;
          return;
        }
      });
      state.draftList.splice(index, 1);
    },    

    SET_EDIT_ORDER_ORIGINAL_ITEM_LIST(state, itemList) {
      state.editOrderItemList = itemList;
    },

    REMOVE_EDIT_ORDER_ITEM(state, item) {
      removeItem(item, state.editOrderItemList);
    },

    ADD_EDIT_ORDER_ORIGINAL_ITEM(state, item) {
      state.editOrderItemList.push(item);
    }
  },
  actions: {
    setOrderDraft({ commit }, orderDraft) {
      commit("SET_ORDER_DRAFT", orderDraft);
    },
    setCurrentDraftId({ commit }, id) {
      commit("SET_CURRENT_DRAFT_ID", id)
    },
    setDraftList({ commit }, draftItems) {
      if (draftItems.orderDraftItemList) {
        commit("SET_DRAFT_LIST", draftItems.orderDraftItemList);
      } else {
        commit("SET_DRAFT_LIST", []);
      }
    },
    removeDraft({ commit }, draftID) {
      commit("REMOVE_DRAFT", draftID);
    },
    initializeEditOrderItems({ dispatch, rootGetters }, { orderItems, order_created_date }) {
      let orderTestSupportObj = rootGetters["orderTest/orderTestSupportObj"];
      let editOrderItems = getEditOrderItemsForDisplay(orderItems, orderTestSupportObj);
      editOrderItems.forEach(item => {
        handleEditOrderItemSelection(item, true, orderTestSupportObj);
        let { sampleTypeSets, isOnMenu } = getEditOrderItemSampleTypes(item, orderTestSupportObj);
        item.sampleTypeSets = sampleTypeSets;
        item.isOnMenu = isOnMenu;
      })
      const testList = [];
      const merchList = [];
      editOrderItems.forEach(item => {
        if (item.item_type != "merchandise") {
          testList.push(item);
        } else {
          merchList.push(item);
        }
      });
      dispatch("setEditOrderItemList", testList);
      if (!_.isEmpty(merchList)) {
        // set merchandise
        // 1. set order date
        dispatch("orderTest/merchandise/setEditOrderDate", order_created_date, { root: true });
        // 2. set merchandise list, replace orginal merchandise if there is one in edit order
        dispatch("orderTest/merchandise/setEditOrderMerchList", merchList, { root: true })
          .then(() => {
            // 3. select these merch
            return dispatch("orderTest/merchandise/setEditOrderSelectedMerchMap", null, { root: true });
          }); 
      }


      // handle exceptions
      handleException("isSelect", "isNotAllowedSelect", orderTestSupportObj);
    },
    setEditOrderItemList({ commit }, editOrderItems) {
      commit("SET_EDIT_ORDER_ORIGINAL_ITEM_LIST", editOrderItems);
    },
    removeEditOrderItem({ commit, rootGetters }, editOrderItem) {
      let orderTestSupportObj = rootGetters["orderTest/orderTestSupportObj"];
      commit("REMOVE_EDIT_ORDER_ITEM", editOrderItem);
      // de-select edit order item
      handleEditOrderItemSelection(editOrderItem, false, orderTestSupportObj);
    }
  }
};

export default orderDraft;